const firebaseConfig = {
    apiKey: "AIzaSyD9Ifkkxq4zfGrIOQWqt1Hw4WyTPS-SzrA",
    authDomain: "grocery-shops-412b4.firebaseapp.com",
    projectId: "grocery-shops-412b4",
    storageBucket: "grocery-shops-412b4.appspot.com",
    messagingSenderId: "541316984007",
    appId: "1:541316984007:web:c1d02f47c01ba5f40a62e2"
};
export default firebaseConfig;